<template>
  <div class="jira-issue-item" @click="openDetails">
    <div :class="`jira-issue-item__status ${displayStatusColor}`">
      <Icon
        v-if="issue.fields.issuetype.name === 'Customer Bug'"
        class="jira-issue-item__status__icon"
      >
        {{ jiraBug }}
      </Icon>
      <Icon
        v-else
        class="jira-issue-item__status__icon"
      >
        {{ jiraFeature }}
      </Icon>
    </div>
    <div class="jira-issue-item__content">
      <span class="jira-issue-item__description">{{ issue.description }}</span>
      <div class="jira-issue-item__informations">
        <div class="jira-issue-item__informations__numbers">
          <span>{{ `${$t('message.ISSUE_ISSUE_ID')}${$t('message.TWO_DOTS')}${issue.id}` }}</span>
          <span>
            {{ `${$t('message.ISSUE_CREATION_DATE')}${$t('message.TWO_DOTS')}${issue.fields.formattedCreatedDate}` }}
          </span>
        </div>
        <span v-if="issue.author">{{ `${$t('message.AUTHOR')}${$t('message.TWO_DOTS')}${issue.author}` }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Display main issue informations from Jira in a row
 * (description, author, creation date, estimated end date, id, status)
 *
 * @vue-prop {Object} issue - The issue object who will contain all details
 */

import Icon from '@/components/icon.vue';
import { jiraFeature, jiraBug } from '@/assets/icons';


export default {
  name: 'JiraIssueItem',

  components: {
    Icon,
  },

  props: {
    issue: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      jiraBug,
      jiraFeature,
    };
  },

  computed: {
    /** Add a custom class from the issue status
     *
     * Status ID:
     * ID 0 = Finished
     * ID 1 = On Going
     * ID 2 = Pending
     * ID 3 = Refused
    */
    displayStatusColor() {
      switch (this.issue.statusId) {
        case 1:
          return 'jira-issue-item__status--on-going';
        case 2:
          return 'jira-issue-item__status--finished';
        case 3:
          return 'jira-issue-item__status--refused';
        default:
          return 'jira-issue-item__status--pending';
      }
    },
    // TO-DO: Waiting for proper tracking issue design to add an estimated end date
  },

  methods: {
    openDetails() {
      this.$router.push({ name: 'jiraIssueDetails', params: { id: this.issue.id } });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/vars.scss';

  .jira-issue-item {
    width: 100%;
    // When changing the following value, the value of the item-size in the RecycleScroller should probably change too
    height: 5em;
    background-color: white;
    position: relative;
    cursor: pointer;

    &__status {
      width: 70px;
      height: 100%;
      position: absolute;
      left: 0;

      &__icon {
        color: white;
        width: 25px;
        height: 25px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: calc(100% - 10px);
      padding: .3em 0;
      margin-left: 6.25em;
    }

    &__description {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding-right: 2em;
    }

    &__informations {
      display: flex;

      span {
        margin-right: 1.3em;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    &__end-date {
      font-weight: bold;
    }

    .jira-issue-item__status--pending {
      background-color: $color-jira-pending;
    }

    .jira-issue-item__status--on-going {
      background-color: $color-jira-on-going;
    }

    .jira-issue-item__status--finished {
      background-color: $color-jira-finished;
    }

    .jira-issue-item__status--refused {
      background-color: $color-jira-refused;
    }

    @media (max-width: $smartphone-portrait) {
      &__content {
        margin-left: 5em;
      }

      &__status {
        width: 50px;
        height: 100%;
        position: absolute;
        left: 0;

        &__icon {
          color: white;
          width: 20px;
          height: 20px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      &__informations {
        flex-direction: column;

        &__numbers {
          display: flex;
        }
      }
    }
  }

</style>
